import { User } from '../../../services';

import { createLogRequest } from '../../../services/requests/app-logs/utils';

export async function createLogForLogin(
  user: User,
  companyId: string,
  companyName: string,
) {
  if (user) {
    await createLogRequest({
      name: user?.name as string,
      user_id: user?.id as string,
      company_id: companyId,
      local: 'Acessos',
      action: 'Acessou',
      description: `Acessou a plataforma na empresa ${companyName}`,
    });
  }
}
